<template>
  <div>
    <component :is="bidComponent" :lot="lot" :bid="bid"></component>
  </div>
</template>

<script>
  import TenderBid from './bids/tender/Main'
  import ReductionBid from './bids/reduction/Main'
  import Errors from '@/api/types/errors'

  export default {
    components: {
      TenderBid,
      ReductionBid
    },

    props: {
      lot: Object,
      bid: Object
    },

    computed: {
      bidComponent() {
        if (this.lot.method.REDUCTION) {
          return ReductionBid
        }
        else {
          return TenderBid
        }
      }
    }
  }
</script>

<style scoped>

</style>
